const rules = {
	user: {
		static: [],
	},

	// supervisor: atende como usuário, vê todos os tickets e a Gestão (relatórios, metas)
	supervisor: {
		static: ["tickets-manager:showall"],
	},

	admin: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
		],
	},
};

export default rules;
